import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import { flexCenterColumn } from '@seedlang/style_mixins';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Stack from 'components/layout/stack';
import CreatorContactUs from 'pages/creator/creator_contact_us';
import { Outlet } from 'react-router-dom';

const Wrapper = styled.div`
  ${flexCenterColumn()}
  width: 100%;
`;

const Group = styled.div`
  width: 100%;
`;

@observer
class GroupShow extends React.Component {
  render() {
    if (AppUI.siteIsSeedlang) return null;
    const showContactUs = AppUI.user?.isAdminForSite(AppUI.site?.id);

    return (
      <Wrapper>
        <Group>
          <Stack gap='sm' alignItems='stretch'>
            <Outlet />
          </Stack>
        </Group>
        {showContactUs && <CreatorContactUs showAdminsOnlyInfo />}
      </Wrapper>
    );
  }
}

export default ErrorBoundary(GroupShow);
